angular.module("vgresiduos").controller("EmailRequestListCtrl", [
	"$rootScope",
	function ($rootScope) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, "organizacao/emails");
		};
	}
]);
